module.exports = __webpack_public_path__ + "img/modulo_Xai.a4ac39b.svg";